export enum OsasPressureUnit {
    cmH2O = 'cm H2O',
    hPa = 'hPa',
}
